import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

const initialState = {
  teamLiability: null,
  fancyLiability: null,
  loading: false,
  error: null,
};

export const fetchTeamLiability = createAsyncThunk(
  "sportEvent/fetchTeamLiability",
  async (matchId, { rejectWithValue }) => {
    try {
      const body = { match_id: String(matchId) };
      const responseBody = await axiosInstance.post("/bet/getTeamPosition", body);
      if (responseBody == null) return null;
      if (typeof responseBody === "object" && responseBody?.status === true) {
        return responseBody?.data ?? null;
      }
      return responseBody;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Team liability fetch failed",
      );
    }
  },
);

export const fetchFancyLiability = createAsyncThunk(
  "sportEvent/fetchFancyLiability",
  async (matchId, { rejectWithValue }) => {
    try {
      const body = { match_id: String(matchId) };
      const responseBody = await axiosInstance.post("/bet/getFancyLiability", body);
      if (responseBody == null) return null;
      if (typeof responseBody === "object" && responseBody?.status === true) {
        return responseBody?.data ?? null;
      }
      return responseBody;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Fancy liability fetch failed",
      );
    }
  },
);

export const toggleFavoriteMarket = createAsyncThunk(
  "sportEvent/toggleFavoriteMarket",
  async ({ eventId, matchId, isAdd, isFancy = false }, { rejectWithValue }) => {
    try {
      const body = {
        event_id: String(eventId),
        is_add: Boolean(isAdd),
        is_fancy: Boolean(isFancy),
        match_id: String(matchId),
      };
      const response = await axiosInstance.post("/match/makeFavouriteV2", body);
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error?.message || "Toggle favorite market failed",
      );
    }
  },
);

const sportEventSlice = createSlice({
  name: "sportEvent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamLiability.fulfilled, (state, action) => {
        state.teamLiability = action.payload ?? null;
      })
      .addCase(fetchTeamLiability.rejected, (state, action) => {
        state.teamLiability = null;
        state.error = action.payload || action.error?.message || null;
      })
      .addCase(fetchFancyLiability.fulfilled, (state, action) => {
        state.fancyLiability = action.payload ?? null;
      })
      .addCase(fetchFancyLiability.rejected, (state, action) => {
        state.fancyLiability = null;
        state.error = action.payload || action.error?.message || null;
      });
  },
});

export default sportEventSlice.reducer;

